import {
  CfDataGridCursorStyle,
  CfDataGridDisplayMode,
  CfDataGridHoverStyle,
  CfDataGridTableViewDefinition,
  NavigableElement,
  RecomputeRowHeightCallback,
  RecomputeRowHeightsCallback,
} from '../../../CfDataGridProps';
import { ValueGetter } from '../CfDataGridTableViewProps';

// Interfaces
export interface CfDataGridRowCommonProps<TItem> {
  tableViewDefinition: CfDataGridTableViewDefinition<TItem>;
  valueGetters: ValueGetter<TItem>[];
  itemIndex: number;
  itemCount: number;
  onItemClicked: ((item: TItem, displayMode: CfDataGridDisplayMode, itemIndex: number) => void) | undefined;
  cursorStyle: CfDataGridCursorStyle<TItem> | undefined;
  hoverStyle: CfDataGridHoverStyle<TItem> | undefined;
  filterText: string | undefined;
  setNavigableElement: (navigableElement: NavigableElement, rowIndex: number, columnIndex: number) => void;
  recomputeRowHeights: RecomputeRowHeightsCallback | undefined;
  recomputeRowHeight: RecomputeRowHeightCallback | undefined;
}

export interface CfDataGridRowProps<TItem> extends CfDataGridRowCommonProps<TItem> {
  item: TItem | undefined;
  previousItem: TItem | undefined;
}

export interface CfDataGridRowByItemIdProps<TItem, TAppState> extends CfDataGridRowCommonProps<TItem> {
  itemId: string | undefined;
  previousItemId: string | undefined;
  itemSelector: (itemId: string, store: TAppState) => TItem | undefined;
  useSelector: (itemSelector: (state: TAppState) => TItem | undefined) => TItem | undefined;
}

export interface CfDataGridRowPropsPassThru<TItem, TAppState> extends CfDataGridRowCommonProps<TItem> {
  item: TItem | undefined;
  previousItem: TItem | undefined;
  itemId?: string | undefined;
  previousItemId?: string | undefined;
  itemSelector?: (itemId: string, store: TAppState) => TItem | undefined;
  useSelector?: (itemSelector: (state: TAppState) => TItem | undefined) => TItem | undefined;
}

// Functions

export function getRowPropsFromRowPropsById<TItem, TAppState>(
  props: CfDataGridRowByItemIdProps<TItem, TAppState>,
  item: TItem | undefined,
  previousItem: TItem | undefined
): CfDataGridRowProps<TItem> {
  const rowProps: CfDataGridRowPropsPassThru<TItem, TAppState> = { item, previousItem, ...props };
  delete rowProps.itemId;
  delete rowProps.previousItemId;
  delete rowProps.itemSelector;
  delete rowProps.useSelector;
  return rowProps;
}
